import { HubConnection } from '@microsoft/signalr'
import { IRemuneracaoBackofficeMessage } from '@/types/interfaces/backoffice-remuneracao/backoffice-remuneracao-message'
import EventBus from '@/plugins/EventBus'
import * as signalR from '@microsoft/signalr'

const env: any = window

class SignalRRemuneracaoBackofficeService {
  private connection?: HubConnection
  private grupoHospitalId?: string
  private canTryReconnectOnCloseConnection = false
  private messageListeners: MessageEventFn[] = []

  async openConnection(grupoHospitalId: string) {
    this.canTryReconnectOnCloseConnection = true
    this.grupoHospitalId = grupoHospitalId

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${env.API_FINX_SIGNALR_REMUNERACAO_BACKOFFICE_GERACAO_REPASSE}`, {
        accessTokenFactory: () => this.accessToken,
      })
      .configureLogging(signalR.LogLevel.Information)
      .build()

    // Create event listners
    this.createListeners()

    try {
      await this.connection!.start()
    } catch (err) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao iniciar a comunicação com o cálculo da remuneração', icon: 'warning', color: '#C62828' })
    }

    try {
      await this.connection.invoke('EntrarGrupoDeCalculoRepasse', grupoHospitalId)
    } catch (err) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao entrar no grupo do cálculo da remuneração', icon: 'warning', color: '#C62828' })
    }

    return this.connection
  }

  /**
   * Kill the current connection
   */
  async closeConnection() {
    this.canTryReconnectOnCloseConnection = false

    try {
      if (this.connection) {
        await this.connection!.stop()
      }
    } catch (err) {
      // eslint-disable-next-line
      console.warn(err)
    }

    this.connection = undefined
  }

  listenMessageEvent(data: MessageEventFn) {
    this.messageListeners.push(data)
  }

  private createListeners() {
    this.connection!.onclose(() => {
      if (this.canTryReconnectOnCloseConnection) {
        this.openConnection(this.grupoHospitalId!)
      }
    })

    this.connection!.on('ReceberFinalizacaoCalculoGeracaoRepasse', (data: any) => {
      console.log('ReceberFinalizacaoCalculoGeracaoRepasse', data)

      EventBus.$emit('atualizarDadosGeracaoRepasse', data)
    })
  }


  private get accessToken() {
    const localStorageData: string = localStorage.getItem(`oidc.user:${env.API_FINX_AUTH}:portal-client-2`)!
    const user: any = JSON.parse(localStorageData)
    return user.access_token
  }
}

type MessageEventFn = (data: IRemuneracaoBackofficeMessage) => void


// eslint-disable-next-line import/prefer-default-export
export const signalRRemuneracaoBackofficeService = new SignalRRemuneracaoBackofficeService()
